import React, { PureComponent, Fragment } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Tooltip, Modal, Row, Col } from 'antd';
import styles from '../style.less';
import StepComponent from './InfoSteps';
import {
  azureAdvancedClientAndTenantIdSteps,
  azureAdvancedSecretKeyAndSubscriptionIdSteps,
  azureBasicClientAndTenantIdSteps,
  azureBasicSecretKeyAndSubscriptionIdSteps,
} from '@/utils/onBoardingSteps';
const FormItem = Form.Item;

class AzureCredentialForm extends PureComponent {
  state = {
    visible: false,
    policy: '',
    visibleSecretKey: false,
  };

  showModal = () => {
    this.setState({
      visible: true,
      visibleSecretKey: false,
    });
  };
  showModalSecretKey = () => {
    this.setState({
      visible: false,
      visibleSecretKey: true,
    });
  };
  handleOk = e => {
    //
    this.setState({
      visible: false,
      visibleSecretKey: false,
    });
  };

  componentDidMount() {
    this.props.setFormRef(this);
  }
  validateForm = () => {
    return this.props.form.validateFields(
      ['SubscriptionID', 'AppId', 'secret', 'TenantID'],
      (err, values) => {
        if (!err) {
          // this.props.form.resetFields();
        }
      }
    );
  };

  handleCancel = e => {
    //
    this.setState({
      visible: false,
      visibleSecretKey: false,
    });
  };
  selectedpolicy(policy) {
    this.props.sentRequireData.selectedpolicy(policy);
    this.setState({
      policy,
    });
  }
  onFormValuesChange = (field, value) => {
    this.props.sentRequireData.providerCallback('authMethodDataAZ', {
      [field]: value,
    });
  };
  render() {
    const { protectionLevel } = this.props.sentRequireData;
    const { getFieldDecorator } = this.props.form;
    const { SubscriptionID, AppId, secret, TenantID } = this.props.authData;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
    };
    return (
      <Fragment>
        {protectionLevel === 'basic' && (
          <div>
            <StepComponent
              heading="Create Application (client) ID & Tenant ID"
              steps={azureBasicClientAndTenantIdSteps}
            />
            <StepComponent
              heading="Create Secret key ID & Subscription ID"
              steps={azureBasicSecretKeyAndSubscriptionIdSteps}
            />
          </div>
        )}
        {protectionLevel === 'advanced' && (
          <div>
            <StepComponent
              heading="Create Application (client) ID & Tenant ID"
              steps={azureAdvancedClientAndTenantIdSteps}
            />
            <StepComponent
              heading="Create Secret key ID & Subscription ID"
              steps={azureAdvancedSecretKeyAndSubscriptionIdSteps}
            />
          </div>
        )}
        <Form layout="horizontal" hideRequiredMark>
          <h5 style={{ marginBottom: '25px', color: 'black' }}>Enter your Azure Credentials</h5>
          <div
            style={{
              padding: '1rem 2rem',
              background: '#FAFAFA',
            }}
          >
            <Row gutter={12}>
              <Col span={12}>
                <p
                  style={{
                    margin: 0,
                  }}
                >
                  AppId/clientId
                </p>
                <FormItem>
                  {getFieldDecorator('AppId', {
                    initialValue: AppId ? AppId : '',
                    getValueFromEvent: event => {
                      this.onFormValuesChange('AppId', event.target.value);
                      return event.target.value;
                    },
                    rules: [
                      {
                        required: true,
                        message: 'Please enter App Id',
                      },
                    ],
                  })(
                    <Input
                      placeholder="App Id"
                      suffix={
                        <Tooltip title="Please find the AppId/clientId from your Azure Console and paste it here">
                          <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                      }
                    />
                  )}
                </FormItem>
              </Col>
              <Col span={12}>
                <p
                  style={{
                    margin: 0,
                  }}
                >
                  Domain/Tenant ID
                </p>

                {/* <FormItem {...formItemLayout} label="Domain/Tenant ID"> */}
                <FormItem>
                  {getFieldDecorator('TenantID', {
                    initialValue: TenantID ? TenantID : '',
                    getValueFromEvent: event => {
                      this.onFormValuesChange('TenantID', event.target.value);
                      return event.target.value;
                    },
                    rules: [
                      {
                        required: true,
                        message: 'Please enter Tenant ID',
                      },
                    ],
                  })(
                    <Input
                      placeholder="Tenant ID"
                      suffix={
                        <Tooltip title="Please find the domain/Tenant ID from your Azure Console and paste it here">
                          <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                      }
                    />
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={12}>
              <Col span={12}>
                <p
                  style={{
                    margin: 0,
                  }}
                >
                  Secret's Value
                </p>
                <FormItem>
                  {getFieldDecorator('secret', {
                    initialValue: secret ? secret : '',
                    getValueFromEvent: event => {
                      this.onFormValuesChange('secret', event.target.value);
                      return event.target.value;
                    },
                    rules: [
                      {
                        required: true,
                        message: 'Please enter Secret Key',
                      },
                    ],
                  })(
                    <Input
                      placeholder="Secret Key"
                      suffix={
                        <Tooltip title="Please find the SecretKey/Pwd from your Azure Console and paste it here">
                          <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                      }
                    />
                  )}
                </FormItem>
              </Col>
              <Col span={12}>
                <p
                  style={{
                    margin: 0,
                  }}
                >
                  Subscription ID
                </p>
                <FormItem>
                  {getFieldDecorator('SubscriptionID', {
                    initialValue: SubscriptionID ? SubscriptionID : '',
                    getValueFromEvent: event => {
                      this.onFormValuesChange('SubscriptionID', event.target.value);
                      return event.target.value;
                    },
                    rules: [
                      {
                        required: true,
                        message: 'Please enter Subscription ID',
                      },
                    ],
                  })(
                    <Input
                      placeholder="Subscription ID"
                      suffix={
                        <Tooltip title="Please find the Subscription ID from your Azure Console and paste it here">
                          <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                      }
                    />
                  )}
                </FormItem>
              </Col>
            </Row>
          </div>
        </Form>
      </Fragment>
    );
  }
}
const WrappedApp = Form.create()(AzureCredentialForm);

export default WrappedApp;
